(() => {
  'use strict';
  if (window.UcwPdpSticky) return;
  const instances = new WeakMap();
  function init(root) {
    if (instances.has(root)) return;
    const controls = root.querySelector('.ucw-v2-cart,.uw-buy');
    if (!controls) return;
    const anchor = document.createElement('div');
    anchor.className = 'ucw-pdp-sticky-anchor';
    controls.before(anchor);
    const host = document.createElement('div');
    host.className = 'ucw-pdp-sticky-host'; host.hidden = true;
    const title = document.createElement('p');
    title.className = 'ucw-pdp-sticky-title';
    title.textContent = root.querySelector('h1')?.textContent.trim() || document.querySelector('main h1')?.textContent.trim() || '';
    host.append(title); root.append(host);
    const mobile = window.matchMedia('(max-width:749px)');
    let active = false, frame = 0;
    const controller = new AbortController();
    function move(parent, before) {
      const focus = document.activeElement;
      const restore = controls.contains(focus);
      parent.insertBefore(controls, before || null);
      if (restore) focus.focus({preventScroll:true});
    }
    function render() {
      frame = 0;
      if (!root.isConnected) return;
      const main = root.closest('#content');
      const footer = main?.querySelector('.shopify-section-group-footer-group');
      const rect = anchor.getBoundingClientRect(), bottom = (footer || main || root).getBoundingClientRect()[footer ? 'top' : 'bottom'];
      const height = active ? host.getBoundingClientRect().height : controls.getBoundingClientRect().height;
      const shouldStick = mobile.matches && rect.top < 0 && bottom > height && !document.querySelector('.uw-cart-popup.is-open');
      if (shouldStick && !active) {
        anchor.style.height = controls.getBoundingClientRect().height + 'px';
        move(host); host.hidden = false; active = true;
      } else if (!shouldStick && active) {
        move(anchor.parentNode, anchor.nextSibling); host.hidden = true;
        anchor.style.height = ''; active = false;
      }
    }
    const schedule = () => {if (!frame) frame = requestAnimationFrame(render);};
    window.addEventListener('scroll',schedule,{passive:true,signal:controller.signal});
    window.addEventListener('resize',schedule,{passive:true,signal:controller.signal});
    mobile.addEventListener('change',schedule,{signal:controller.signal});
    const resize = new ResizeObserver(schedule); resize.observe(controls);
    instances.set(root, () => {controller.abort(); resize.disconnect(); cancelAnimationFrame(frame); if(active) move(anchor.parentNode,anchor.nextSibling); anchor.remove();host.remove();instances.delete(root);});
    render();
  }
  const scan = (scope = document) => scope.querySelectorAll('[data-ucw-pdp-mode]').forEach(init);
  window.UcwPdpSticky = {scan}; scan();
  document.addEventListener('shopify:section:load',event=>scan(event.target));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-ucw-pdp-mode]').forEach(root=>instances.get(root)?.()));
})();
